import { LIMIT_USAGE } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import LimitUsageSection from 'pricing-pages-ui-components/limit-usage/LimitUsageSection';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { getPrimaryTracker } from 'usage-tracker-container';
import { useIsFreePortal } from '../../v2/hooks/useProductInventory';
import ComparePlansLink from '../common/ComparePlansLink';
import RecommendedStarterFeatureTableContainer from './RecommendedStarterFeatureTableContainer';
import RecommendedStarterFooter from './RecommendedStarterFooter';
import RecommendedStarterHeaderBanner from './RecommendedStarterHeaderBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedStarterCustomerPlatformContainer = () => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RecommendedStarterHeaderBanner, {}), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(LimitUsageSection, {
        isFreePortal: isFreePortal && !isInventoryLoading,
        usageTracker: getPrimaryTracker(),
        earlyRequestName: LIMIT_USAGE
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(RecommendedStarterFeatureTableContainer, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(RecommendedStarterFooter, {})
    })]
  });
};
export default RecommendedStarterCustomerPlatformContainer;